import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import CheckCircle from "../../Icons/CheckCircle";
import SendLetter from "../../Icons/SendLetter";
import FollowCall from "../../Icons/FollowCall";
import { isSyncing, isSynced, isSyncFailed, isPartSynced } from '../../../utils/salesforceUtils';
import { ORDER_TYPES } from "../../../constants/OrderValues";

const styles = () => ({
  root: {
    display: "flex",
    alignItems: 'center',
    marginRight: 25,
    marginLeft: 15,
    whiteSpace: 'nowrap',
  },

  icon: {
    marginRight: 5,
    height: "15px",
    width: "15px",
  },

  statusIcon: {
    width: "18px",
    height: "18px",
    background: "#F2F6FF",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "5px",
  },
});

class SalesforceSyncStatus extends React.Component {
  renderIcon = () => {
    const { classes, type } = this.props;

    return (
      <div className={classes.statusIcon} style={{ backgroundColor: "#F2F6FF" }}>
        {(() => {
          if (type === ORDER_TYPES.LETTER) {
            return (<SendLetter width={15} height={15} color="#6F9EFF" />);
          } else if (type === ORDER_TYPES.FOLLOW_CALL) {
            return (<FollowCall width={10} height={10} color="#6F9EFF" />);
          } else {
            return null;
          }
        })()}
      </div>
    );
  }

  render() {
    const { classes, item, type } = this.props;

    return (
      <React.Fragment>
        <div className={classes.root}>
        {this.renderIcon()}
          <CheckCircle
            color="#1A65FF"
            width={15}
            height={15}
            className={classes.icon}
          />
          {(() => {
            if (isSyncing(item, type)) {
              return 'Salesforceと同期中';
            } else if (isSynced(item, type)) {
              return 'Salesforceと同期済';
            } else if (isSyncFailed(item, type)) {
              return 'Salesforceと同期失敗';
            } else if (isPartSynced(item, type)) {
              return 'Salesforceと一部同期済';
            }
            })()}
        </div>
      </React.Fragment>
    )
  }
}

SalesforceSyncStatus.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  type: PropTypes.number.isRequired,
};

export default withStyles(styles)(SalesforceSyncStatus);



// WEBPACK FOOTER //
// ./src/components/OrderDetail/parts/SalesforceSyncStatus.jsx